import { isOpenFin } from 'utils'

export * from './ActivityIndicator'
export const ActivityMonitor = isOpenFin() ? require('./ActivityMonitorOpenFin').default : require('./ActivityMonitorBrowser').default
